import {HttpErrorResponse} from "@angular/common/http";
import {createAction, props} from "@ngrx/store";
import {IGetCategoriesItemDto} from "../../main/pages/categories.dto";
import * as storeKeys from './../store-key.config';

const scope = `${storeKeys.categories}`;

export const fetchCategories = createAction(`${scope} Fetch Categories Filters`);
export const fetchCategoriesSuccess = createAction(`${scope} Fetch Categories Filters Success`, props<{
    categories: IGetCategoriesItemDto[]
}>());
export const fetchCategoriesFailure = createAction(`${scope} Fetch Categories Filters Failure`, props<{
    error: HttpErrorResponse
}>());
